import { BuildTripViewType, CalendarViewType, StaffViewType } from '@sd-portal/shared/models';
import { MonthlyCalendarRibbonType } from './monthly-calendar-ribbon-type.enum';

export interface CalendarConfiguration {
  // keys
  calendarConfigurationId: number;
  // settings
  calendarViewTypeId: CalendarViewType;
  monthlyRibbonTypeId: MonthlyCalendarRibbonType;
  staffViewTypeId: StaffViewType;
  monthlyShowPilotInitials: boolean;
  monthlyShowPaxCount: boolean;
  monthlyShowAircraftLastKnownLocation: boolean;
  initComplete: boolean;
  staffShowTails: boolean,
  staffShowStaff: boolean,
  staffShowMetrics: boolean,
  weekShowStaff: boolean
  weekShowTails: boolean;
  isAutoRefresh: boolean;
  autoRefreshTimeInMinutes: number;
  useFlattenedCalendar: boolean;
  buildTripViewTypeId: BuildTripViewType;
}

export const DEFAULT_CALENDAR_CONFIGURATION: CalendarConfiguration = {
  calendarConfigurationId: 0,
  calendarViewTypeId: CalendarViewType.Week,
  monthlyRibbonTypeId: MonthlyCalendarRibbonType.Trip,
  staffViewTypeId: StaffViewType.TailNumber,
  monthlyShowPilotInitials: false,
  monthlyShowPaxCount: false,
  monthlyShowAircraftLastKnownLocation: false,
  initComplete: false,
  staffShowTails: false,
  staffShowStaff: true,
  staffShowMetrics: false,
  weekShowStaff: false,
  weekShowTails: true,
  isAutoRefresh: false,
  autoRefreshTimeInMinutes: 5,
  useFlattenedCalendar: false,
  buildTripViewTypeId: BuildTripViewType.Vertical
};
